import { useLoadSyncs } from 'shared/hooks/use-load-syncs';
import { useSyncsSubscription } from 'shared/hooks/use-syncs-subscription';

import { SyncPill } from './SyncPill';
import { SyncPopover } from './SyncPopover';

export const SyncStatus = () => {
  const { syncs } = useLoadSyncs();

  useSyncsSubscription();

  if (!syncs?.length) return null;
  if (syncs.length === 1) return <SyncPill sync={syncs[0]} />;

  return <SyncPopover syncs={syncs} />;
};
